module.exports = __webpack_public_path__ + "static/gym-f7b887dfef7fc6088ca495e4146d75eb.jpg";